export function externalOrderIdLabel(channelName) {
    const name = String(channelName || '').trim();
    return name ? `ID ${name}` : 'ID do pedido no canal';
}

/** "Shopee" + id when the marketplace order id exists; channel name alone otherwise. */
export function salesChannelKanbanLabel(channelName, externalOrderId) {
    const name = String(channelName || '').trim();
    const id = String(externalOrderId || '').trim();
    if (name && id) {
        return `${name} ${id}`;
    }
    return name || id || '—';
}

function normalizeSalesChannelKey(channelName) {
    return String(channelName || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '');
}

export function isMercadoLivreSalesChannel(channelName) {
    const key = normalizeSalesChannelKey(channelName);
    return key === 'mercadolivre' || key.startsWith('mercadolivre');
}

export function isShopeeSalesChannel(channelName) {
    const key = normalizeSalesChannelKey(channelName);
    return key === 'shopee' || key.startsWith('shopee');
}

/** Fundo da linha na lista de pedidos: shopee, mercado_livre ou vazio. */
export function orderListChannelTint(channelName) {
    if (isShopeeSalesChannel(channelName)) {
        return 'shopee';
    }
    if (isMercadoLivreSalesChannel(channelName)) {
        return 'mercado_livre';
    }
    return '';
}

export function mercadoLivreSellerOrderUrl(channelName, externalOrderId) {
    const id = String(externalOrderId || '').trim();
    if (!id || !isMercadoLivreSalesChannel(channelName)) {
        return null;
    }
    return `https://vendedores.mercadolivre.com.br/vendas/${encodeURIComponent(id)}/detalhe`;
}

export function normalizeExternalOrderUrl(raw) {
    const value = String(raw || '').trim();
    if (!value) {
        return '';
    }
    try {
        const parsed = new URL(value);
        if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
            return '';
        }
        return parsed.toString();
    } catch {
        return '';
    }
}

/** Prefer explicit panel URL; fallback to known marketplace builders (ex.: Mercado Livre). */
export function resolveExternalOrderLink({ salesChannelName, externalOrderId, externalOrderUrl } = {}) {
    const explicit = normalizeExternalOrderUrl(externalOrderUrl);
    if (explicit) {
        return explicit;
    }
    return mercadoLivreSellerOrderUrl(salesChannelName, externalOrderId);
}
